import { z } from 'zod'
import { Model } from '../../_kernel/architecture'
import { countryDataSource } from '../../_datasource/CountryDatasource'
import type { CountryConfigKey } from './CountryConfig'

const TRUSTPILOT_SUPPORTED_LOCALES = new Set([
  'en-GB',
  'en-US',
  'en-IE',
  'de-DE',
  'de-AT',
  'es-ES',
  'fr-FR',
  'it-IT',
  'da-DK',
  'nl-NL',
  'nl-BE',
  'fr-BE',
  'fi-FI',
  'pl-PL',
  'pt-PT',
  'en-ZA',
  'en-CA',
  'fr-CA',
  'en-AU',
  'ar-SA-u-ca-gregory-nu-latn',
])

export const FROM_COUNTRY_CONFIG_TO_LOCALE: Record<CountryConfigKey, string> = Object.entries(
  countryDataSource
).reduce(
  (acc, [key, value]) => {
    acc[key as CountryConfigKey] = value.locale
    return acc
  },
  {} as Record<CountryConfigKey, string>
)

export const LocaleValidation = z.object({
  value: z.string().min(1, { message: '[Locale] value is required' }),
})

export class Locale extends Model {
  static create({ value }: z.infer<typeof LocaleValidation>) {
    LocaleValidation.parse({ value })
    return new Locale(value)
  }

  static createOrNull({ value }: z.infer<typeof LocaleValidation>): Locale | null {
    try {
      return Locale.create({ value })
    } catch {
      return null
    }
  }

  constructor(private readonly _value: string) {
    super()
  }

  get value() { return this._value } // prettier-ignore

  isSupportedByTrustPilot(): boolean {
    return TRUSTPILOT_SUPPORTED_LOCALES.has(this._value)
  }
}
